import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import DayConfiguration from 'modules/work_schedules/store/models/DayConfiguration'

export class DayConfigurations extends Collection<DayConfiguration> {
  get cacheKey(): string {
    return 'dayConfigurations'
  }

  model() {
    return DayConfiguration
  }

  get indexes() {
    return ['overlap_period_id']
  }

  getDayConfigsByPeriod(id: string): DayConfiguration[] {
    return this.filter({ overlap_period_id: id })
  }
}

const singleton: DayConfigurations = new DayConfigurations()

export default singleton

const { provider: DayConfigurationsProvider, hook: useDayConfigurations } = createCollectionContext<
  DayConfiguration,
  DayConfigurations
>()

export { DayConfigurationsProvider }
